export const FETCH_CASHIN_RAPYD_METHODS_REQUEST = 'FETCH_CASHIN_RAPYD_METHODS_REQUEST';
export const FETCH_CASHIN_RAPYD_METHODS_SUCCESS = 'FETCH_CASHIN_RAPYD_METHODS_SUCCESS';
export const FETCH_CASHIN_RAPYD_METHODS_FAILURE = 'FETCH_CASHIN_RAPYD_METHODS_FAILURE';

export const FETCH_CASHIN_RAPYD_FEE_REQUEST = 'FETCH_CASHIN_RAPYD_FEE_REQUEST';
export const FETCH_CASHIN_RAPYD_FEE_SUCCESS = 'FETCH_CASHIN_RAPYD_FEE_SUCCESS';
export const FETCH_CASHIN_RAPYD_FEE_FAILURE = 'FETCH_CASHIN_RAPYD_FEE_FAILURE';

export const FETCH_CASHIN_RAPYD_REQUEST = 'FETCH_CASHIN_RAPYD_REQUEST';
export const FETCH_CASHIN_RAPYD_SUCCESS = 'FETCH_CASHIN_RAPYD_SUCCESS';
export const FETCH_CASHIN_RAPYD_FAILURE = 'FETCH_CASHIN_RAPYD_FAILURE';

export const FETCH_CASHIN_RAPYD_CALLBACK_REQUEST = 'FETCH_CASHIN_RAPYD_CALLBACK_REQUEST';
export const FETCH_CASHIN_RAPYD_CALLBACK_SUCCESS = 'FETCH_CASHIN_RAPYD_CALLBACK_SUCCESS';
export const FETCH_CASHIN_RAPYD_CALLBACK_FAILURE = 'FETCH_CASHIN_RAPYD_CALLBACK_FAILURE';
